export default "__VITE_ASSET__C5aGudLd__"